module.exports = __webpack_public_path__ + "static/favicon-56ed36637400a63dccd2ae360f33b7b9.ico";